
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/[stateElection]/candidates/[candidate]",
      function () {
        return require("private-next-pages/elections/[stateElection]/candidates/[candidate].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/[stateElection]/candidates/[candidate]"])
      });
    }
  